import { useState, useCallback } from "react";

interface CellSelectConfig<T> {
    onClearOtherSelections?: () => void;
}

export const useSingleCellSelect = <T>(config?: CellSelectConfig<T>) => {
    const [selectedCell, setSelectedCell] = useState<T | null>(null);

    const handleCellSelect = useCallback((cell: T, event?: React.MouseEvent) => {
        setSelectedCell((prev) => {
            // If clicking the same cell, deselect it
            if (prev && JSON.stringify(prev) === JSON.stringify(cell)) {
                return null;
            }
            return cell;
        });

        // Clear other selections unless Ctrl/Shift is pressed
        if (config?.onClearOtherSelections && 
            !(event && (event.ctrlKey || event.shiftKey || event.metaKey))) {
            config.onClearOtherSelections();
        }
    }, [config]);

    const clearSelection = useCallback(() => {
        setSelectedCell(null);
    }, []);

    const isSelected = useCallback((cell: T) => {
        return selectedCell && JSON.stringify(selectedCell) === JSON.stringify(cell);
    }, [selectedCell]);

    return {
        selectedCell,
        handleCellSelect,
        clearSelection,
        isSelected,
    };
};